import { TemplateWithPOIs } from '@/types';
import { createSvgIcon } from '@mui/material';

const WorkscopeSquareIcon = createSvgIcon(
  <rect
    x="1.5"
    y="1.5"
    width="10"
    height="10"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    vectorEffect="non-scaling-stroke"
    />,
  'Workscope'
);

type Props = {
  location: TemplateWithPOIs['pointOfInterests'][0]['location'];
  scale: [number, number, number];
};

export const DeckplanOverlayWorkscopeSvg = ({ location, scale }: Props) => {
  const { cx, cy } = location;
  const [width, height] = scale;
  return (
    <svg height={height * 100} width={width * 100} x={cx} y={cy}>
      <WorkscopeSquareIcon style={{ color: 'red' }} />
    </svg>
  );
};
